module.exports = __webpack_public_path__ + "img/loader.7ef8f552.png";